export const API_URL = getAPIURL();
export const UserPanel_API_URL = getUserPanelAPIURL();

function getAPIURL(){
    let url;
    switch(window.location.host) {
      case 'asmtadmin.easetolearn.com':
        url = 'https://asmtapi.easetolearn.com';
        break;
      case 'www.asmtadmin.easetolearn.com':
        url = 'https://asmtapi.easetolearn.com';
        break;
      case 'asmtadminuat.easetolearn.com':
          url = 'https://asmtapiuat.easetolearn.com';
          break;
      case 'www.asmtadminuat.easetolearn.com':
          url = 'https://asmtapiuat.easetolearn.com';
          break;
      default:
        url = 'http://localhost:8099';
        //url = 'https://asmtapi.easetolearn.com';
        ///url = 'https://asmtapiuat.easetolearn.com';
    }
    return url;
}

function getUserPanelAPIURL() {
  let url;
  switch (window.location.host) {
    case 'asmtadmin.easetolearn.com':
      url = "https://userapi.easetolearn.com";
      break;
    case 'www.asmtadmin.easetolearn.com':
      url = "https://userapi.easetolearn.com";
      break;
    case 'asmtadminuat.easetolearn.com':
      url = "https://userapiuat.easetolearn.com";
      break;
    case "localhost:3000":
      url = 'http://localhost:8098';
      //url = "https://userapi.easetolearn.com";
      //url = "https://userapiuat.easetolearn.com";
      break;
    default:
      url = "https://userapi.easetolearn.com";
  }
  return url;
}